import React, { Component } from "react";
import ModalAdd from "../form/ModalAlergi";
import ModalRemove from "../form/ModalDelete";
import API from "../../apiService.js";

export default class Alergi extends Component {
  constructor(props) {
    super(props);
    this.state = {
      patient: this.props.patient,
      patient_id: this.props.patient.patient_id,
      modalShow: false,
      modalDel: false,
      delete: {
        url: "registration/allergies/delete/",
        id: null,
        name: "Makanan A",
        explain: "alergi",
      },
      allergy: [],
      detail: [],
      flag: [],
    };

    this.parentCallback = this.parentCallback.bind(this);
  }

  componentDidMount() {
    this.getAllergies();
  }

  parentCallback(data) {
    this.setState({
      patient: {
        ...this.state.patient,
        patients: {
          ...this.state.patient.patients,
          allergies: data,
        },
      },
    });
  }

  getAllergies = async () => {
    const res = await API.get("management/allergies/read");
    if (res.code === 200) {
      this.setState({
        allergy: res.data,
      });
    }
  };

  handleAlergi = (e) => {
    this.setState({
      modalShow: true,
    });
  };

  handleDelete = (e) => {
    this.setState({
      modalDel: true,
    });
  };

  render() {
    let modalShow = this.state.modalShow;
    let modalDel = this.state.modalDel;
    let check = this.state.patient.patients.allergies;
    const allergies = this.state.allergy.map((allergy, keys) => {
      let color = check.find(
        (set) => set.detail.type_id === allergy.id && !set.log
      )
        ? "#f5365c"
        : "";
      return (
        <div key={allergy.id} className="col-md-3">
          <div
            className="card-header"
            id={"heading" + allergy.id}
            data-toggle="collapse"
            data-target={"#collapse" + allergy.id}
            aria-expanded="false"
            aria-controls={"collapse" + allergy.id}
          >
            <h4 style={{ color: color }} className="checklist-title mb-0">
              Alergi {allergy.name}
            </h4>
          </div>
          <div
            id={"collapse" + allergy.id}
            className="collapse"
            aria-labelledby={"heading" + allergy.id}
            data-parent="#accordionExample"
          >
            <div className="card-body">
              <div className="row">
                <div className="col-12">
                  <ul className="list-group">
                    {this.state.patient.patients.allergies.map(
                      (details, key) => {
                        return details.detail.type_id == allergy.id &&
                          !details.log ? (
                          <li className="list-group-item" key={details.id}>
                            <div className="row align-items-center">
                              <div className="col-9">
                                <strong>{details.explanation}</strong>
                                <br></br>
                                <small>{details.detail.name}</small>
                              </div>
                              <div className="col">
                                <button
                                  className="btn btn-sm btn-block btn-danger"
                                  onClick={(e) =>
                                    this.setState({
                                      delete: {
                                        url:
                                          "registration/allergies/delete/" +
                                          details.id,
                                        id: key,
                                        name: "Alergi " + details.detail.name,
                                        explain:
                                          "Alergi " + details.explanation,
                                      },
                                      modalDel: true,
                                    })
                                  }
                                >
                                  -
                                </button>
                              </div>
                            </div>
                          </li>
                        ) : (
                          ""
                        );
                      }
                    )}
                  </ul>
                </div>
                <div className="col-12">
                  <br></br>
                  <button
                    className="btn btn-sm btn-primary btn-block"
                    onClick={(e) =>
                      this.setState({
                        detail: allergy.details,
                        modalShow: true,
                      })
                    }
                  >
                    Tambah Alergi {allergy.name}
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-default btn-block"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    LOG
                  </button>
                  <div className="dropdown-menu">
                    {this.state.patient.patients.allergies.map(
                      (details, key) => {
                        return details.detail.type_id == allergy.id &&
                          details.log ? (
                          <div key={key} className="dropdown-item">
                            {details.detail.name}{" "}
                            <mark>{details.explanation}</mark>
                          </div>
                        ) : (
                          ""
                        );
                      }
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
    return (
      <div className="accordion" id="accordionExample">
        <div className="row">
          {allergies}

          {modalDel ? (
            <ModalRemove
              show={modalDel}
              onHide={() => this.setState({ modalDel: false })}
              patient={this.props.patient}
              delete={this.state.delete}
              parentCallback={this.parentCallback}
            />
          ) : (
            ""
          )}
          {modalShow ? (
            <ModalAdd
              show={modalShow}
              onHide={() => this.setState({ modalShow: false })}
              patient={this.props.patient}
              detail={this.state.detail}
              parentCallback={this.parentCallback}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}
